// 使用通用布局的路由配置

export default [{
  name: 'example',
  meta: {
    title: '页面示例',
    icon: 'help'
  },
  children: [{
    name: 'form',
    component: () => import('@/views/Example/Form'),
    meta: {
      title: '基础表单'
    }
  }, {
    name: 'detail',
    component: () => import('@/views/Example/Detail'),
    meta: {
      title: '基础详情页'
    }
  }, {
    name: 'adv-detail',
    component: () => import('@/views/Example/AdvDetail'),
    meta: {
      title: '高级详情页'
    }
  }]
}, {
  name: 'table',
  redirect: 'operation',
  meta: {title: '表格示例', icon: 'reorder'},
  children: [{
    name: 'index',
    component: () => import('@/views/Table/index'),
    meta: {title: 'table for display'}
  }, {
    name: 'operation',
    component: () => import('@/views/Table/operation'),
    meta: {title: 'table for operation'}
  }]
}, {
  name: 'product',
  children: [{
    name: 'detail',
    params: ['id'],
    component: () => import('@/views/Product/product-detail'),
    meta: {
      title: '商品'
    }
  }, {
    name: 'search',
    query: ['keyword', 'hasStock', 'marks', 'secondCates', 'sortPrice', 'page'],
    component: () => import('@/views/Product/search'),
    meta: {
      title: '搜索'
    }
  }]

},{
  name: 'cart',
  children: [{
    name: 'index',
    component: () => import('@/views/Cart/index'),
    meta: { title: '购物车', showTabbar: true }
  }, ]
},{
  name: 'member',
  children: [{
    name: 'index',
    component: () => import('@/views/Member/index'),
    meta: { title: '我的', showTabbar: true }
  }, {
    name: 'order-detail',
    params: ['id'],
    component: () => import('@/views/Member/OrderDetail'),
    meta: { hideBreadcrumb: true }
  }, {
    name: 'member-address',
    component: () => import('@/views/Member/MemberAddress'),
    meta: {title: '收货地址管理'}
  },{
    name: 'address-add',
    component: () => import('@/views/Member/MemberAddressAdd'),
    meta: {title: '添加收货地址'}
  }, {
    name: 'order-refund',
    params: ['id'],
    component: () => import('@/views/Member/Refund'),
    meta: {title: '申请退款', type: 'confirm' }
  }, {
    name: 'order-refund-detail',
    params: ['id'],
    component: () => import('@/views/Member/Refund'),
    meta: {title: '退款详情', type: 'detail'}
  }, {
    name: 'agreement',
    params: ['name'],
    component: () => import('@/views/Member/Agreement'),
    meta: {title: '协议', type: 'agreement'}
  }],
},{
  name: 'order',
  children: [{
    name: 'confirm',
    component: () => import('@/views/Order/confirm'),
    meta: { title: '订单确认' }
  }],
}, {
  name: 'pay',
  children: [{
    name: 'index',
    params: ['id'],
    props: true,
    component: () => import('@/views/Pay/index'),
    meta: {
      title: '订单提交成功',
      hideBreadcrumb: true
    }
  }, {
    name: 'pay',
    params: ['id'],
    props: true,
    component: () => import('@/views/Pay/pay'),
    meta: {
      title: '支付'
    }
  }, {
    name: 'callback',
    params: ['payMethod', 'id'],
    props: true,
    component: () => import('@/views/Pay/Callback'),
    meta: {
      title: '支付结果确认'
    }
  }, {
    name: 'return',
    params: ['payMethod', 'id'],
    props: true,
    component: () => import('@/views/Pay/success'),
    meta: {
      title: '支付成功'
    }
  }]
}]
